<div class="ml-20px mt-20px">
  <span> Where are you from? </span>
  <ui-radio-group [(ngModel)]="radioValue" uiSize="large">
    <label ui-radio-button uiValue="S">Sofia</label>
    <label ui-radio-button uiValue="P">Plovdiv</label>
    <label ui-radio-button uiValue="B">Burgas</label>
    <label ui-radio-button uiValue="V">Varna</label>
  </ui-radio-group>
  <br />
  <br />
  <span> Where are you from? </span>
  <ui-radio-group id="radio-group-solid" [(ngModel)]="radioValue" uiButtonStyle="solid" uiName="radio-group-name">
    <label ui-radio-button uiValue="S">Sofia</label>
    <label ui-radio-button uiValue="P">Plovdiv</label>
    <label ui-radio-button uiValue="B" uiDisabled>Burgas</label>
    <label ui-radio-button uiValue="V">Varna</label>
  </ui-radio-group>
  -- Solid
  <br />
  <br />
  <span> Where are you from? </span>
  <ui-radio-group [(ngModel)]="radioValue" uiSize="small" (ngModelChange)="radioChanged($event)">
    <label ui-radio-button uiValue="S">Sofia</label>
    <label ui-radio-button uiValue="P" uiDisabled>Plovdiv</label>
    <label ui-radio-button uiValue="B">Burgas</label>
    <label ui-radio-button uiValue="V">Varna</label>
  </ui-radio-group>
  <br />
  <br />
  <span> Disabled group </span>
  <ui-radio-group id="radio-group-disabled" [(ngModel)]="radioValue" uiSize="small" (ngModelChange)="radioChanged($event)" uiDisabled>
    <label ui-radio-button uiValue="S">Sofia</label>
    <label ui-radio-button uiValue="P">Plovdiv</label>
    <label ui-radio-button uiValue="B">Burgas</label>
    <label ui-radio-button uiValue="V">Varna</label>
  </ui-radio-group>
  <br />
  <br />
  <span> What is the capitol of Czech Republic? </span>
  <ui-radio-group [(ngModel)]="capitol" (ngModelChange)="radioChanged($event)">
    <label ui-radio uiValue="S">Sofia</label>
    <label id="radio-button-plovdiv" ui-radio uiValue="Pl" uiDisabled>Plovdiv</label>
    <label id="radio-button-prague" ui-radio uiValue="Pr" uiAutoFocus>Prague</label>
    <label ui-radio uiValue="B">Berlin</label>
  </ui-radio-group>
</div>
